module.exports = __webpack_public_path__ + "img/ddwu_main0.5e05f5ed.jpg";